// window.onload = function(e){
//     var e = document.getElementsByTagName("script");
//     for (var i = 0; i < e.length; i++) {
//       if (e[i].hasAttribute('src') && e[i].getAttribute('src') == 'https://app.youpay.ai/shopify.js?shop=ocd-skateshop.myshopify.com') {
//         e[i].remove();
//       }
//     }
// }
window.onload = function(e){
    var e = document.getElementsByTagName("script");
    for (var i = 0; i < e.length; i++) {
        if (e[i].hasAttribute('src') && e[i].getAttribute('src') == 'https://cdn.shopify.com/s/files/1/0475/6461/9930/t/105/assets/metastock.js?v=128934216340822626921678245840') {
            e[i].remove();
        }
    }
}
